import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { EProductType, ProcessSheets, Product, TId } from 'src/app/models';
import { ProcessSheetsResource} from 'src/app/resources';
import {
  ProductsProcessSheetsAddComponent
} from '../../../products-process-sheets/products-process-sheets-add/products-process-sheets-add.component';

@Component({
  selector: 'app-product-process-sheets-add',
  templateUrl: './product-process-sheets-add.component.html',
  styleUrl: './product-process-sheets-add.component.sass',
  standalone: false
})
export class ProductProcessSheetAddComponent extends GenericCrudAddComponent<ProcessSheets> {
  processSheets?: ProcessSheets[] = [];
  product?: Product;
  createProcessSheetComponent = ProductsProcessSheetsAddComponent;
  createdProcessSheetId?: TId;

  protected override async preFetch(): Promise<void> {
    this.product = this.initialFormValues.product;
    this.processSheets = await firstValueFrom(this.api.resources.product.processSheets.getAll())
  }
  initFormGroup(): FormGroup {
    const group = this.fb.group({
      processSheetId:[undefined],
    });
    return group;
  }
  override async createEntity(): Promise<void> {
    try {
      if (await this.validateEntity()) {
        let processSheetId = this.form?.value.processSheetId
        this.product?.processSheetList.push(this.form?.value.processSheetId);
        this.product!.processSheetList = [...new Set(this.product?.processSheetList)];
        await firstValueFrom(this.api.resources.product.products.put(this.product!));
        if(this.createdProcessSheetId){
          processSheetId = this.createdProcessSheetId
          const versions = await firstValueFrom(this.api.resources.product.processSheetsVersions(this.createdProcessSheetId).getAll());
          const revisions = await firstValueFrom(this.api.resources.product.processSheetsRevisions(this.createdProcessSheetId, versions[0].id).getAll());
          await firstValueFrom(this.api.resources.product.processSheetsRevisionsProducts(this.createdProcessSheetId, versions[0].id, revisions[0].id).post({
            processSheetId: this.createdProcessSheetId,
            productId: this.product?.id,
            productTypeId:EProductType.Product,
            quantity: 1,
            productFormatId: this.product?.stockFormatId,

          } as any));
        }
        const processSheet = await firstValueFrom((this.api.resources.product.processSheets as unknown as ProcessSheetsResource).getProcessSheet(processSheetId));
        this.entityCreated.emit(processSheet);
      }
    } catch (error) {
      this.alertSrv.error(error);
    }
  }

  async createProcessSheet($event: TId) {
    this.createdProcessSheetId = $event
  }

}
